import React from "react";
import type { I18nContextValue } from "./useI18n";

export const I18nContext = React.createContext<I18nContextValue | null>(null);
